module.exports = __webpack_public_path__ + "static/img/1.bf490f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/home/1.png
// module id = WaeK
// module chunks = 2